import '@ungap/custom-elements';
import { defineCustomElement } from 'vue';
import PrimeVue from 'primevue/config';
import * as initDatadog from '~/monitoring/datadog';
import initSentry from '~/monitoring/init_sentry';

export interface PrimeVueConfig {
    ripple?: boolean;
}

const defaultConfig: PrimeVueConfig = {
    ripple: false,
};

export function defineCustomVueElement({ component, name }: { component: any; name: string }) {
    const isIntOrProdEnv = ['int', 'prod'].includes(DEPLOY_ENV);

    // Load Plus Jakarta Sans font for all widgets
    if (!document.querySelector('link[href*="Plus+Jakarta+Sans"]')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700&display=swap';
        document.head.appendChild(link);
    }

    // Initialize Datadog RUM
    if (isIntOrProdEnv || INIT_DATADOG) {
        initDatadog.default();
    }

    const customElement = defineCustomElement(component, {
        shadowRoot: true,
        configureApp(app) {
            // Initialize Sentry monitoring
            if (isIntOrProdEnv || INIT_SENTRY) {
                initSentry(app, DEPLOY_ENV, name, component);
            }

            // Configure PrimeVue for the widget's isolated Vue instance
            app.use(PrimeVue, {
                // PrimeVue configuration options
                ...defaultConfig,
            });
        },
    });

    // Register the custom element
    if (!customElements.get(name)) {
        customElements.define(name, customElement);
    }
    return customElement;
}
